import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../context/UserContext';
import { hasPrivilege } from '../utils/hasPrivilege';
import { useLocation } from 'react-router-dom';
import Select from 'react-select';
import { CSVLink } from 'react-csv';
import Swal from 'sweetalert2';
import { FiChevronDown, FiRefreshCw } from 'react-icons/fi';

const AcademyCoachList = () => {
  const { userData } = useUser();
  const location = useLocation();
  const { selectedCenter } = useUser();
  const [searchTerm, setSearchTerm] = useState('');
  const [coaches, setCoaches] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [academyOptions, setAcademyOptions] = useState([]);
  const [selectedAcademy, setSelectedAcademy] = useState(null);
  const [selectedRole, setSelectedRole] = useState(null);
  const [selectedCoachType, setSelectedCoachType] = useState(null);
  const [roleOptions, setRoleOptions] = useState([]);
  const [coachTypeOptions, setCoachTypeOptions] = useState([]);
  useEffect(() => {
    fetchCoachData();
  }, []);

  const fetchCoachData = () => {
    setLoading(true);

    fetch(process.env.REACT_APP_API_COACH_LIST_CBU, {
      method: "GET",
      headers: {
        'Content-Type': 'application/json',
        'x-authorization': process.env.REACT_APP_AUTH_TOKEN,
      },
    })
      .then((response) => response.json())
      .then((responseData) => {
        if (responseData.success && responseData.data?.data?.length > 0) {
          const academies = responseData.data.data.map((academy) => ({
            value: academy.academyId.toString(),
            label: academy.academyName,
          }));

          const mobileToCoachMap = {};

          responseData.data.data.forEach((academy) => {
            academy.coach.forEach((coach) => {
              const mobile = coach.contactNo.replace(/^\+91/, '');

              if (!mobileToCoachMap[mobile]) {
                mobileToCoachMap[mobile] = {
                  Coachid: coach.coachId,
                  id: coach.coachUserId,
                  name: coach.coachName.trim(),
                  mobileNumber: mobile,
                  gender: coach.gender || "Unknown",
                  coachDetails: coach.about || "-",
                  experienceInMonth: coach.experienceInMonth || 0,
                  joiningDate: coach.joiningDate
                    ? new Date(coach.joiningDate).toLocaleDateString()
                    : "N/A",
                  is_CTU: false,
                  is_CBU: false,
                  is_headCoach: false,
                  is_juniorCoach: false,
                  academyListForRole: new Set(),
                  role: coach.coachRole || "",
                  coachType: coach.coachType || "",
                  academyId: academy.academyId,
                  mainAcademyName: "",
                };
              }

              const coachData = mobileToCoachMap[mobile];
              if (coach.coachType) {
                coachData.mainAcademyName = academy.academyName;
                coachData.mainAcademyId = academy.academyId;
              }

              if (coach.coachRole?.toLowerCase() === "ctu") {
                coachData.is_CTU = true;
                coachData.academyListForRole = new Set(["All"]);
                coachData.role = "ctu";
              } else if (coach.coachRole?.toLowerCase() === "cbu") {
                coachData.is_CBU = true;
                if (!coachData.academyListForRole.has("All")) {
                  coachData.academyListForRole.add(academy.academyName);
                }
                coachData.role = "cbu";
              }

              if (coach.coachType?.toLowerCase() === "head") {
                coachData.is_headCoach = true;
                coachData.coachType = "head";
              }

              if (coach.coachType?.toLowerCase() === "junior") {
                coachData.is_juniorCoach = true;
                coachData.coachType = "junior";
              }

              coachData.experienceInMonth = Math.max(coachData.experienceInMonth, coach.experienceInMonth || 0);
            });
          });

          const coaches = Object.values(mobileToCoachMap).map((coach) => ({
            ...coach,
            experience: coach.experienceInMonth
              ? `${Math.floor(coach.experienceInMonth / 12)} years ${coach.experienceInMonth % 12} months`
              : "N/A",
            academyListForRole: Array.from(coach.academyListForRole).join(", "),
          }));

          const uniqueRoles = [...new Set(coaches.map((coach) => coach.role).filter(Boolean))];
          const uniqueCoachTypes = [...new Set(coaches.map((coach) => coach.coachType).filter(Boolean))];

          const roleOptions = uniqueRoles.map((role) => ({
            value: role,
            label: role ? role.toUpperCase() : "Unknown",
          }));

          const coachTypeOptions = uniqueCoachTypes.map((type) => ({
            value: type,
            label: type ? type.charAt(0).toUpperCase() + type.slice(1) : "Unknown",
          }));

          setAcademyOptions(academies);
          setCoaches(coaches);
          setRoleOptions(roleOptions);
          setCoachTypeOptions(coachTypeOptions);

          const defaultAcademy = academies.find(a => a.value === selectedCenter);
          if (defaultAcademy) {
            setSelectedAcademy(defaultAcademy.value);
          }
        } else {
          setCoaches([]);
        }
      })
      .catch((error) => console.error("Error fetching data:", error))
      .finally(() => setLoading(false));
  };



  const getAcademyName = (academyId) => {
    const academy = academyOptions.find((a) => String(a.value) === String(academyId));
    return academy ? academy.label : "Unknown Academy";
  };

  const headers = [
    { label: "Academy Name", key: "Academyname" },
    { label: "Coach Name", key: "name" },
    { label: "Contact Number", key: "mobileNumber" },
    { label: "Gender", key: "gender" },
    { label: "Coach Details", key: "coachDetails" },
    { label: "Experience", key: "experience" },
    { label: "is CBU", key: "is_CBU" },
    { label: "is CTU", key: "is_CTU" },
    { label: "is head coach", key: "is_headCoach" },
    { label: "Junior coach", key: "is_juniorCoach" },
    { label: "Joining Date", key: "joining date" },
    { label: "CBU/CTU Academy List", key: "academyListForRole" },

  ];

  const [dropdownOpen, setDropdownOpen] = useState(null);
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setrowsPerPage] = useState(10);

  const handleItemsPerPageChange = (event) => {
    setrowsPerPage(Number(event.target.value));
    setCurrentPage(1);
  };

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
    setCurrentPage(1);
  };

  const filteredCoaches = coaches.filter((coach) => {
    const academyMatch = !selectedAcademy || String(coach.mainAcademyId) === String(selectedAcademy);
    const roleMatch = !selectedRole || coach.role === selectedRole.value;
    const coachTypeMatch =
      !selectedCoachType ||
      (selectedCoachType.value === "Unknown" && (!coach.coachType || coach.coachType === "Unknown")) ||
      (selectedCoachType.value !== "Unknown" && coach.coachType === selectedCoachType.value);

    const searchMatch =
      !searchTerm ||
      coach.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      coach.mobileNumber.includes(searchTerm);

    return academyMatch && roleMatch && coachTypeMatch && searchMatch;
  });



  const [sortConfig, setSortConfig] = useState({
    key: "name",
    direction: "ascending",
  });
  const handleSort = (columnKey) => {
    let direction = "ascending";
    if (sortConfig.key === columnKey && sortConfig.direction === "ascending") {
      direction = "descending";
    }
    setSortConfig({ key: columnKey, direction });
  };

  const sortData = (data) => {
    const { key, direction } = sortConfig;
    return [...data].sort((a, b) => {
      if (a[key] < b[key]) return direction === "ascending" ? -1 : 1;
      if (a[key] > b[key]) return direction === "ascending" ? 1 : -1;
      return 0;
    });
  };

  const sortedData = sortData(filteredCoaches);

  const handlePageClick = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = sortedData.slice(indexOfFirstRow, indexOfLastRow);
  const totalPages = Math.ceil(sortedData.length / rowsPerPage);

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage((prevPage) => prevPage + 1);
  };

  const handlePrevPage = () => {
    if (currentPage > 1) setCurrentPage((prevPage) => prevPage - 1);
  };

  const generatePageNumbers = () => {
    const pages = [];
    const totalPagesToShow = 5;

    if (totalPages <= totalPagesToShow) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      pages.push(1);
      if (currentPage > 3) pages.push('...');
      for (let i = Math.max(2, currentPage - 1); i <= Math.min(totalPages - 1, currentPage + 1); i++) {
        pages.push(i);
      }
      if (currentPage < totalPages - 2) pages.push('...');
      pages.push(totalPages);
    }
    return pages;
  };

  const renderPagination = () => {
    return generatePageNumbers().map((page, index) =>
      typeof page === 'number' ? (
        <button
          key={index}
          className={`page-number ${currentPage === page ? 'active' : ''}`}
          onClick={() => handlePageClick(page)}
        >
          {page}
        </button>
      ) : (
        <span key={index} className="pagination-dots">
          {page}
        </span>
      )
    );
  };

  const totalEntries = filteredCoaches.length;
  const indexOfFirstEntry = totalEntries > 0 ? (currentPage - 1) * rowsPerPage + 1 : 0;
  const indexOfLastEntry = totalEntries > 0 ? Math.min(currentPage * rowsPerPage, totalEntries) : 0;
  const handleEdit = (event, coachId) => {
    const url = `/createCoach?coachId=${coachId}`;
    if (event.metaKey || event.ctrlKey) {
      window.open(url, "_blank");
    } else {
      navigate(url);
    }
  };


  const handleDelete = async (coachId) => {
    const result = await Swal.fire({
      icon: 'warning',
      title: 'Are you sure?',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, delete it!',
    });

    if (!result.isConfirmed) return;

    try {
      const endpoint = `${process.env.REACT_APP_API_COACH_DELETE_CBU}?coachId=${coachId}`;
      const response = await fetch(endpoint, {
        method: 'DELETE',
        headers: {
          'x-authorization': process.env.REACT_APP_AUTH_TOKEN,
          'Content-Type': 'application/json',
        }
      });

      const data = await response.json();
      if (response.ok) {
        Swal.fire({
          icon: 'success',
          title: 'Success',
          text: 'Coach deleted successfully!',
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000,
        });

        setCoaches(prevCoaches => prevCoaches.filter(coach => coach.Coachid !== coachId));
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: data.message || 'Failed to delete coach.',
        });
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Something went wrong while deleting the category.',
      });
    }

  }
  return (
    <div className="enrollment-container">
      <div className="sales-filters-login">
        <div className="floating-select">
          <Select
            className={`sales-filter-court-booking ${selectedAcademy ? "has-value" : ""}`}
            classNamePrefix="react-select"
            options={academyOptions}
            value={academyOptions.find(option => option.value === selectedAcademy)}
            onChange={(selectedOption) => setSelectedAcademy(selectedOption?.value || '')}
            placeholder="Select Academy"
            menuPortalTarget={document.body}
            styles={{
              placeholder: (provided) => ({
                ...provided,
                color: 'black',
              }),
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            }}
            isClearable={userData.roles?.includes("super admin")}
          />
          {selectedAcademy && <label htmlFor="selectedAcademy">Academy</label>}
        </div>

        <div className="floating-select">
          <Select
            className={`sales-filter-court-booking ${selectedRole ? "has-value" : ""}`}
            classNamePrefix="react-select"
            options={roleOptions}
            value={selectedRole}
            onChange={(selectedOption) => setSelectedRole(selectedOption)}
            placeholder="Select Role"
            isClearable
            menuPortalTarget={document.body}
            styles={{
              placeholder: (provided) => ({
                ...provided,
                color: 'black',
              }),
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            }}
          />
          {selectedRole && <label htmlFor="selectedRole">Role</label>}
        </div>

        <div className="floating-select">
          <Select
            className={`sales-filter-court-booking ${selectedCoachType ? "has-value" : ""}`}
            classNamePrefix="react-select"
            options={coachTypeOptions}
            value={selectedCoachType}
            onChange={(selectedOption) => setSelectedCoachType(selectedOption)}
            placeholder="Coach Type"
            isClearable
            menuPortalTarget={document.body}
            styles={{
              placeholder: (provided) => ({
                ...provided,
                color: 'black',
              }),
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            }}
          />
          {selectedCoachType && <label htmlFor="selectedCoachType">Coach Type</label>}
        </div>



      </div>
      <div className="search-bar">
        <div className="input-container">
          <input
            type="text"
            id="searchInput"
            placeholder=""
            className={`search-input ${searchTerm ? "has-value" : ""}`}
            value={searchTerm}
            onChange={handleSearchChange}
          />
          <label htmlFor="searchInput" className="floating-label">
            🔍 Search
          </label>
        </div>
        <CSVLink
          data={filteredCoaches}
          headers={headers}
          filename="CoachList.csv"
          className="btn btn-primary no-decoration"
        >
          <button className="csv_button" type="button" >
            <span
              className="button__text"

            >
              Export CSV
            </span>
            <span className="button__icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 35 35" className="svg">
                <path d="M17.5,22.131a1.249,1.249,0,0,1-1.25-1.25V2.187a1.25,1.25,0,0,1,2.5,0V20.881A1.25,1.25,0,0,1,17.5,22.131Z"></path>
                <path d="M17.5,22.693a3.189,3.189,0,0,1-2.262-.936L8.487,15.006a1.249,1.249,0,0,1,1.767-1.767l6.751,6.751a.7.7,0,0,0,.99,0l6.751-6.751a1.25,1.25,0,0,1,1.768,1.767l-6.752,6.751A3.191,3.191,0,0,1,17.5,22.693Z"></path>
                <path d="M31.436,34.063H3.564A3.318,3.318,0,0,1,.25,30.749V22.011a1.25,1.25,0,0,1,2.5,0v8.738a.815.815,0,0,0,.814.814H31.436a.815.815,0,0,0,.814-.814V22.011a1.25,1.25,0,1,1,2.5,0v8.738A3.318,3.318,0,0,1,31.436,34.063Z"></path>
              </svg>
            </span>
          </button>
        </CSVLink>

        {/* <button className="create-button">Create Coach</button> */}
      </div>

      <div className="items-and-dues">
        <select className="items-per-page-select" value={rowsPerPage} onChange={handleItemsPerPageChange}>
          <option value={10}>10 items per page</option>
          <option value={50}>50 items per page</option>
          <option value={75}>75 items per page</option>
          <option value={100}>100 items per page</option>
        </select>
        <div className="pagination-selector">
          <div className="button-group">
            <div className="group-label">Items per page:</div>
            <div className="button-options">
              {[10, 50, 75, 100].map((option) => (
                <button
                  key={option}
                  onClick={() =>
                    handleItemsPerPageChange({ target: { value: option } })
                  }
                  className={`page-button ${rowsPerPage === option ? 'active' : ''}`}
                >
                  <span className="button-text">{option}</span>
                </button>
              ))}
            </div>
          </div>
        </div>
        <button className="tt-action-btn" onClick={fetchCoachData}>
          <FiRefreshCw className={`refresh-icon ${loading ? 'spin' : ''}`} />
          Refresh
        </button>

      </div>
      {loading && (
        <div className="premium-loader">
          <div className="progress-track">
            <div className="progress-bar"></div>
          </div>
          <div className="status-text">
            <span>L</span>
            <span>O</span>
            <span>A</span>
            <span>D</span>
            <span>I</span>
            <span>N</span>
            <span>G</span>
          </div>
        </div>
      )}
      {error && <div className="error-message">{error}</div>}
      {!loading && !error && filteredCoaches.length === 0 && (
        <div className="error-message">No data available</div>
      )}

      <div className="tt-table-container">
        <table className="tt-table">
          <thead>
            <tr>
              {headers.map(({ key, label }) => (
                <th key={key} className="challenges-column" onClick={() => handleSort(key)}>
                  <div className="th-content">
                    <span>{label}</span>
                    <FiChevronDown
                      className={`sort-icon ${sortConfig.key === key ? 'active' : ''
                        } ${sortConfig.direction === 'descending' && sortConfig.key === key ? 'desc' : ''}`}
                    />
                  </div>
                </th>
              ))}

              {hasPrivilege(userData, 'CBU', 'COACH_LIST_MODIFY') && (
                <th>Action</th>
              )}
            </tr>
          </thead>

          <tbody>
            {currentRows.map((coach) => (
              <tr key={coach.coachId}>
                <td>{coach.mainAcademyName || "Unknown Academy"}</td>
                <td>{coach.name}</td>
                <td>{coach.mobileNumber}</td>
                <td>{coach.gender}</td>
                <td>{coach.coachDetails}</td>
                <td>{coach.experience}</td>
                <td>{coach.is_CBU ? "Yes" : "No"}</td>
                <td>{coach.is_CTU ? "Yes" : "No"}</td>
                <td>{coach.is_headCoach ? "Yes" : "No"}</td>
                <td>{coach.is_juniorCoach ? "Yes" : "No"}</td>
                <td>{coach.joiningDate}</td>
                <td className="academy-dropdown-cell">
                  {coach.is_CBU ? (
                    <details>
                      <summary>View Academies</summary>
                      <div className="academy-dropdown-list">
                        {coach.academyListForRole.split(', ').map((academy, index) => (
                          <div key={index} className="academy-name">
                            {academy}
                          </div>
                        ))}
                      </div>
                    </details>
                  ) : (
                    <span>{coach.academyListForRole}</span>
                  )}
                </td>

                {hasPrivilege(userData, 'CBU', 'COACH_LIST_MODIFY') && (
                  <td className="action-buttons" style={{ borderBottom: "none" }}>
                    <button onClick={(e) => handleEdit(e, coach.Coachid)} className="edit-btn tooltip-btn">
                      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="white" strokeWidth="2">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M16.862 3.487a2.12 2.12 0 0 1 3.001 3.001L7.5 18.85l-4 1 1-4L16.862 3.487z" />
                      </svg>
                      <span className="tooltip-text">Edit</span>
                    </button>
                    <button onClick={() => handleDelete(coach.Coachid)} className="delete-btn tooltip-btn">
                      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="white" strokeWidth="2">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M6 7h12M9 7V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2M10 11v6M14 11v6M5 7h14l-1 12a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 7z" />
                      </svg>
                      <span className="tooltip-text">Delete</span>
                    </button>
                  </td>
                )}
              </tr>
            ))}
          </tbody>

        </table>
      </div>

      <div className="pagination">
        <div className="showing-entries">
          Showing {indexOfFirstEntry} to {indexOfLastEntry} of {totalEntries} entries
        </div>
        <button
          className="prev-button"
          onClick={handlePrevPage}
          disabled={currentPage === 1}
        >
          Previous
        </button>
        {renderPagination()}
        <button
          className="next-button"
          onClick={handleNextPage}
          disabled={currentPage === totalPages}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default AcademyCoachList;